import { Component, effect, inject, signal } from '@angular/core';
import { LoginFacade } from '../../../state/login.facade';
import { ConfigService } from '../../../../services/config.service';
import { ParameterType, RegisterOption } from '../../../../models/client-configuration';
import { FormBuilderService } from '../../../../services/form-builder.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { LoginDialogComponent } from '../../login-dialog/login-dialog.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent {
  private readonly loginFacade = inject(LoginFacade);
  private readonly configService = inject(ConfigService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly dialogRef = inject(MatLegacyDialogRef<LoginDialogComponent>);

  private readonly recoverPasswordResponse = toSignal(this.loginFacade.recoverPasswordResponse$);

  readonly customMessage = signal(this.configService.get().rememberPasswordMessage);
  readonly forgotPasswordInputLabel = signal(this.getForgotPasswordInputLabel());

  form: FormGroup = this.formBuilder.group({
    identifier: ['', Validators.required],
  });

  constructor() {
    // TODO: Remove this code when opac dialog will be implemented
    effect(() => {
      if (this.recoverPasswordResponse() === true) {
        this.dialogRef.close();
        this.loginFacade.closeDialog();
      }
    });
  }

  loadLogin() {
    this.loginFacade.changeScreen('login');
  }

  recoverPassword(event: SubmitEvent) {
    event.preventDefault();

    const identifier = this.form.value.identifier;
    this.loginFacade.recoverPassword(identifier);
  }

  private getForgotPasswordInputLabel(): string {
    const registerOptions = this.getRegisterOptions();
    const externalIdParam = registerOptions[0].fields
      .find((f) => f.tipoParametro === ParameterType.IDENTIFICADOR_EXTERNO);
    const idAlias = this.getRegisterOptions()[0].fields
      .find((f) => f.tipoParametro === ParameterType.VALUE_ALIAS);
    const externalIdValues = externalIdParam.defaultValue.split(';');

    if (!externalIdParam) {
      return '';
    }

    if (externalIdValues.length > 1) {
      return 'user.fields.id';
    }

    if (idAlias?.defaultValue) {
      return idAlias.defaultValue;
    }

    return FormBuilderService.getSelectLabel(Number(externalIdValues[0]));
  }

  private getRegisterOptions(): RegisterOption[] {
    const options = this.configService.get().registerOptions;

    let accountParameters: RegisterOption[] = options.map((o) => {
      o.fields = o.fields.filter((f) => f.alta === true);
      return o;
    });

    if (!this.configService.get().multipleSignUp) {
      accountParameters = [accountParameters.shift()];
    }

    return accountParameters;
  }
}
